<template>
  <div class="downloadList">
    <DownloadItem
      class="downloadList-item"
      v-for="item in items"
      :key="item.title"
      :item="item"
    />
  </div>
</template>

<script>
import DownloadItem from "./DownloadItem";
export default {
  name: "DownloadItemListDesktop",
  components: {
    DownloadItem,
  },
  props: {
    items: Array,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/";

.downloadList {
  @include flex-h(space-around, flex-end);
  flex-wrap: wrap;
  color: white;
  height: 100%;
  padding: 120px;
  overflow: auto;
}
</style>
